module.exports = __webpack_public_path__ + "img/电子证书盖章图.a70eb80a.png";